import './streamResponseRecorderGlobals';
import { getStreamResponseOutput } from './getStreamResponseOutput';

/**
 * Installs the `__rovoStreamResponseOutput__` getter on `window.top`.
 */
export const installStreamResponseOutputGetter = (): void => {
	try {
		if (window.top) {
			window.top.__rovoStreamResponseOutput__ = getStreamResponseOutput;
		}
	} catch {
		// Ignore cross-origin frame access errors
	}
};
